export default "__VITE_ASSET__d32071cd__"